import React from 'react';
import { arrayOf, shape, string, number } from 'prop-types';
import i18next from 'i18next';
import cn from 'classnames';
import { useSelector } from 'react-redux';

import styles from '../../styles.module.scss';
import QuantityAndPrice from '../../../QuantityAndPrice';

import { getFlatItems, groupModifiersByParent } from './utils';

function ProductDetails({ items }) {
  const showParentModifier = useSelector((state) => state?.core?.settings?.showParentModifier) || false;

  return (
    <div className={`column ${styles.border}`}>
      {getFlatItems(items).map(({ name, modifiers, price, key, totalQuantity, instructions }) => (
        <div key={key} className="row m-left-2 m-right-2 m-top-2">
          <span className={styles.subtitle}>{totalQuantity}</span>
          <div className="m-left-4 column full-width">
            <div className="row middle space-between">
              <span className={`bold ${styles.subtitle}`}>{name}</span>
              <QuantityAndPrice quantity={totalQuantity} price={price} />
            </div>
            <div className="full-width">
              {Object.entries(groupModifiersByParent(modifiers, showParentModifier)).map(
                ([parentName, groupedModifiers]) => (
                  <div className="column full-width" key={parentName}>
                    {showParentModifier ? <span className="m-top-2">{parentName}</span> : null}
                    {groupedModifiers.map((modifier) => (
                      <div
                        className={cn(
                          `row m-top-1 full-width m-right-2 middle space-between ${styles.modifierContainer}`,
                          {
                            'm-top-2': !showParentModifier
                          }
                        )}
                        key={modifier.name}>
                        <span className={styles.modifier}>{`${modifier.quantity} ${modifier.name}`}</span>
                        <QuantityAndPrice price={modifier.price} quantity={modifier.quantity} />
                      </div>
                    ))}
                  </div>
                )
              )}
            </div>
            {instructions ? (
              <span className={`m-top-2 ${styles.instructions}`}>
                <span className="bold">{i18next.t('OrdersDetails:aditionalInstructions')}</span>
                {` ${instructions}`}
              </span>
            ) : null}
          </div>
        </div>
      ))}
    </div>
  );
}

ProductDetails.propTypes = {
  items: arrayOf(
    shape({
      name: string.isRequired,
      quantity: number.isRequired,
      price: number.isRequired,
      modifiers: arrayOf(
        shape({
          parents: arrayOf(shape({ name: string.isRequired })),
          quantity: number.isRequired,
          name: string.isRequired
        })
      )
    })
  ).isRequired
};

export default ProductDetails;
